import {Injectable, OnDestroy, OnInit} from '@angular/core';
import {Observable} from 'rxjs/internal/Observable';
import {BehaviorSubject} from 'rxjs/internal/BehaviorSubject';

@Injectable({
    providedIn: 'root'
})
export class InternetConnectionService implements OnInit, OnDestroy {

    connectionStatus = true;
    connection$;
    private readonly _connectionStatusSubject$: BehaviorSubject<boolean>;

    constructor() {
    }

    get connectionStatus$(): Observable<boolean> {
        return this._connectionStatusSubject$.asObservable();
    }

    get isEnabled(): boolean {
       /* this.connection$ = this.connectionStatus$.subscribe(data => {
            this.connectionStatus = data.valueOf();
        });
        if (!this.connectionStatus) {
            return false;
        } else {
            return true;
        }*/
       return true;
    }

    ngOnInit() {
    }

    ngOnDestroy(): void {
        if (this._connectionStatusSubject$) {
            this._connectionStatusSubject$.unsubscribe();
        }
        if (this.connection$) {
            this.connection$.unsubscribe();
        }
    }
}
